import { Random } from '@zedoc/random';

// In-memory only — not copied when a tab is duplicated (sessionStorage is).
const editorSessionId = Random.id();

export function getProjectWizardEditorSessionId() {
  return editorSessionId;
}
